<template>
  <Card dis-hover>
    <!-- 问题处理速度 -->
    <div slot="title">
      <slot name="title"></slot>
      <p class="title-item">{{ this.$t('common.this_month') }}</p>
    </div>
    <a href="#" slot="extra">
      <slot name="extra"></slot>
    </a>
    <div class="content">
      <div class="content-left test-1">
        <board-eight-item
          v-for="(item, index) in problemsAfterSort"
          :key="index"
          :problemItem="item"
          :maxProblem="maxProblem"
        ></board-eight-item>
        <Spin v-if="problemsLoading" fix>
          {{ $t('common.loading_data') }}
        </Spin>
        <div
          v-if="!problemsLoading && (!problems || problems.length === 0)"
          class="no-data"
        >
          {{ $t('common.no_data') }}
        </div>
      </div>
      <div class="right">
        <div
          class="item"
          v-for="(item, index) in itemList"
          :key="index"
          @click="sortByItem(item)"
        >
          <span
            :style="{
              display: 'inline-block',
              height: '12px',
              width: '12px',
              borderRadius: '3px',

              backgroundColor: item.color,
            }"
          ></span>
          <span
            style="margin-left: 10px; font-size: 12px; padding: 3px"
            :class="{ sort: item.sort }"
            >{{ item.name }}</span
          >
        </div>
      </div>
      <div style="flex-basis: 100%; display: flex; justify-content: space-around; margin-top: 10px">
        <Page :total="totalPage" :page-size="20" :current.sync="currentPage" size="small" @on-change="initInfo" />
      </div>
    </div>
  </Card>
</template>
<script>
import boardEightItem from './boardEightItem.vue';
import api from '../../../api/home/index';
export default {
  components: {
    boardEightItem,
  },
  data() {
    return {
      sortWay: 'top',
      itemList: [],
      maxProblem: 0,
      problemsAfterSort: [],
      showAppeal: false,
      totalPage: null,
      currentPage: 1,
      // 整改流程
      flowType: [
        { name: 'AI_inspect_shop', drag: 0, key: 10 }, // AI巡店
        { name: 'other_type', drag: 0, key: 5 }, // 其他情况
        { name: 'video_inspect_shop', drag: 1, key: 3 }, // 视频巡店
        { name: 'manual', drag: 1, key: 4 }, // 手动创建
        { name: 'alarm', drag: 1, key: 7 }, // 告警
        { name: 'scene_inspect_shop', drag: 1, key: 8 }, // 现场巡店
        { name: 'remote', drag: 1, key: 9 }, // 远程巡店
        { name: 'capture', drag: 1, key: 6 }, // 快拍
        { name: 'shake_inspect_shop', drag: 1, key: 2 }, // 摇一摇巡店
      ],

      problemsLoading: false,
      problems: [],
    };
  },
  mounted() {
    this.initInfo();
  },
  methods: {
    // 初始化数据
    initInfo() {
      debugger;
      this.problemsLoading = true;
      let params = {
        timeRange: 5,
        tagIdList: [],
        sourceTypeList: [],
        showCompare: 0,
        deptNode: [],
        checkerType: 2,
        role: [],
        user: [],
        templateId: [],
        sort: 'desc',
        pageNumber: this.currentPage,
        pageSize: 20,
      };
      api
        .problemProgressSummary(params)
        .then(res => {
          let resInfo = this.sortByKey(res.content);
          this.problems = resInfo;
          this.dealProblems(resInfo);
          this.problemsLoading = false;
          this.totalPage =  res.totalCount;
        })
        .catch(e => {
          console.log(e);
        });
    },
    // 获取申诉流程、申诉+整改流程、申诉时间
    async getAppealFlow(cb) {
      try {
        const userInfo = this.$system.$state.userInfo;
        let groupId = userInfo && userInfo.groupId ? userInfo.groupId : 0;
        // 获取申诉流程
        const data = await api.getAppealFlow({ enterpriseId: groupId });
        // 获取申诉+整改流程
        const dataBoth = await api.getDoubleFlow({
          enterpriseId: groupId,
        });
        const appealFlow = data.map(item => item.sourceType) || [];
        const doubleFlow = dataBoth.map(item => item.sourceType) || [];
        this.showAppeal = this.flowType.some(f => {
          return (
            appealFlow.indexOf(f.key) !== -1 || doubleFlow.indexOf(f.key) !== -1
          );
        });
        if (this.showAppeal) {
          this.itemList = [
            {
              name: this.$t('common.status1'),
              color: '#f45f81',
              type: 'toRectification',
              sort: false,
            },
            {
              name: this.$t('common.status2'),
              color: '#ffaf75',
              type: 'toRecheck',
              sort: false,
            },
            {
              name: this.$t('common.status3'),
              color: '#e85fff',
              type: 'toAppeal',
              sort: false,
            },
            {
              name: this.$t('common.status4'),
              color: '#6d60ff',
              type: 'appealNotPass',
              sort: false,
            },
            {
              name: this.$t('common.status5'),
              color: '#f5db40',
              type: 'toApproval',
              sort: false,
            },
            {
              name: this.$t('common.status6'),
              color: '#16dfb0',
              type: 'appealPass',
              sort: false,
            },
            {
              name: this.$t('common.status7'),
              color: '#9bec5e',
              type: 'rectificationComplete',
              sort: false,
            },
            {
              name: this.$t('common.status8'),
              color: '#1A94E6',
              type: 'expired',
              sort: false,
            },
          ];
        } else {
          this.itemList = [
            {
              name: this.$t('common.status1'),
              color: '#f45f81',
              type: 'toRectification',
              sort: false,
            },
            {
              name: this.$t('common.status2'),
              color: '#ffaf75',
              type: 'toRecheck',
              sort: false,
            },
            {
              name: this.$t('common.status7'),
              color: '#9bec5e',
              type: 'rectificationComplete',
              sort: false,
            },
            {
              name: this.$t('common.status8'),
              color: '#1A94E6',
              type: 'expired',
              sort: false,
            },
          ];
        }
        cb && cb(this.showAppeal);
      } catch (e) {
        console.log(e);
      }
    },
    sortByItem(item) {
      this.itemList.forEach(aitem => {
        if (aitem.type !== item.type) {
          aitem.sort = false;
        }
      });
      item.sort = !item.sort;
      if (item.sort) {
        this.sortByKey(this.problemsAfterSort, item.type);
      } else {
        this.problemsAfterSort = [...item];
      }
    },
    sortByKey(array, sortKey) {
      return array.sort(function (a, b) {
        if (b[sortKey] === a[sortKey]) {
          let x =
            a.appealNotPass +
            a.appealPass +
            a.rectificationComplete +
            a.toAppeal +
            a.toApproval +
            a.toRecheck +
            a.toRectification +
            a.expired;
          let y =
            b.appealNotPass +
            b.appealPass +
            b.rectificationComplete +
            b.toAppeal +
            b.toApproval +
            b.toRecheck +
            b.toRectification +
            b.expired;
          return y - x;
        }
        return b[sortKey] - a[sortKey];
      });
    },
    dealProblems(item) {
      if (item.length > 0) {
        this.getAppealFlow(showAppeal => {
          let problemsAfterSort = [...item];
          problemsAfterSort = problemsAfterSort.map(item => {
            if (!showAppeal) {
              item.toAppeal = 0;
              item.appealNotPass = 0;
              item.toApproval = 0;
              item.appealPass = 0;
            }
            return item;
          });
          this.maxProblem =
            problemsAfterSort[0].toRectification +
            problemsAfterSort[0].toRecheck +
            problemsAfterSort[0].toAppeal +
            problemsAfterSort[0].appealNotPass +
            problemsAfterSort[0].toApproval +
            problemsAfterSort[0].appealPass +
            problemsAfterSort[0].rectificationComplete +
            problemsAfterSort[0].expired;
          this.problemsAfterSort = problemsAfterSort;
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.top-line {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .title {
    display: inline-block;
    margin-right: 5px;
    font-weight: 600;
    font-size: 16px;
    color: #333333;
  }
}
::v-deep {
  .ivu-card-head p {
    width: auto;
  }
}
.title-item {
  padding: 0 5px;
  height: 18px;
  background: #f0f0f0;
  border-radius: 3px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  font-size: 12px;
  color: #b2b2b2;
  letter-spacing: 0;
  line-height: 16px;
  text-align: center;
  margin-left: 6px;
}
.content {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  .content-left {
    // width: 100%;
    height: 200px;
    overflow: auto;
  }
  // .scrollbar {
  //   width: 10px;
  //   height: 300px;
  //   margin: 0 auto;
  // }
  .test-1::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 3px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }
  .test-1::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px #cccccc;
    background: #cccccc;
  }
  .test-1::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px #fff;
    border-radius: 10px;
    background: #fff;
  }
  .right {
    padding-left: 50px;
    // padding-top: 10px;
    .item {
      height: 18px;
      margin-bottom: 7px;
      cursor: pointer;
    }
  }
}
.sort {
  background-color: #f0f0f0;
  border-radius: 3px;
  font-weight: 600;
}
</style>
